import { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import clsx from "classnames";
import { useQuery } from "@apollo/client";
import { getConfigGQL, meGQL, Query } from "@onmo/graphql/graphql";
import { User } from "../../../models/user";
import { useStyles } from "./LevelUpAnimation.style";
import { Typography } from "../../core/Typography/Typography";
import {
  TypographyColor,
  TypographyVariant,
} from "../../../constants/typography";
import Badge from "../../core/Badge/Badge";
import { useWalletConfig } from "../../../hooks/useWalletConfig";

export const LevelUpAnimation: FC<{ autoHideRoot?: boolean }> = ({
  autoHideRoot,
}) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const { data: dataConfig } = useQuery(getConfigGQL);
  const { data: dataMe } = useQuery<Query>(meGQL);

  const [hideLevelup, setHideLevelup] = useState(false);
  const { walletConfig } = useWalletConfig();
  const baseCoinType = walletConfig.primaryCurrency.base;
  const userRank = User.getCurrentRank({
    wallet: dataMe?.me?.coinWallets,
    tierLevels: dataConfig?.config?.tierLevels,
    baseCoinType,
    xp: dataMe?.me?.xp,
  });

  if (!userRank) return null;

  return (
    <div
      className={clsx(
        classes.root,
        hideLevelup && classes.hideRoot,
        autoHideRoot && classes.autoHideRoot,
      )}
      onClick={() => setHideLevelup(true)}
    >
      <div className={classes.main}>
        <div className={classes.content}>
          <Badge
            size="m"
            type={userRank.preLevel.id}
            className={clsx(classes.rank, classes.hideOld)}
          />
          <Badge
            size="m"
            type={userRank.id}
            className={clsx(classes.nextRank, classes.showNext)}
          />
          <Typography
            variant={TypographyVariant.HeadingH3Bold}
            color={TypographyColor.Default}
            className={classes.title}
          >
            {t("common_Level up")}
          </Typography>
          <Typography
            variant={TypographyVariant.HeadingH5Bold}
            color={TypographyColor.Silver}
            className={clsx(classes.rankName, classes.hideRankName)}
          >
            {t(`${userRank.preLevel?.name}`)}
          </Typography>
          <Typography
            variant={TypographyVariant.HeadingH5Bold}
            color={TypographyColor.Silver}
            className={clsx(classes.rankName, classes.showRankName)}
          >
            {t(`${userRank.name}`)}
          </Typography>
          <Typography
            variant={TypographyVariant.HeadingH6Bold}
            className={classes.labelOutSide}
          >
            {t(`Tap anywhere to continue`)}
          </Typography>
        </div>
      </div>
    </div>
  );
};
